export const noticeSchema = spec => {
  return { type: spec.type,
           id: spec.id,
           msg: spec.msg,
           timeout: spec.timeout || 10000,
           onComplete: spec.onComplete || null,
           show: spec.show }
}



// WEBPACK FOOTER //
// ./src/schema/notices.js